import angular from 'angular'

import getSize from '../utils/get-size'
import extractRawElm from '../utils/extract-raw-elm'

import { drawArea, removeLines } from '../utils/draw-rectangle'

angular
  .module('ggs.gallery-modal')
  .factory('modalDrawBounds', ModalDrawBoundsProvider)

const ITEM_QS = '.ggs-gml__item'
const CURR_QS = '.ggs-gml__item_current'
const HOR_PANE_QS = '.ggs-gallery-modal__component__pane_horizontal-layout'
const VER_PANE_QS = '.ggs-gallery-modal__component__pane_vertical-layout'
const VER_HEAD_QS = '.ggs-gallery-modal__component__head'

function ModalDrawBoundsProvider(domh) {
  return function modalDrawBounds($elm, bounds) {
    const cntr = extractRawElm($elm).closest(ITEM_QS)
    if (!cntr) {
      return
    }

    removeLines(cntr)

    if (!bounds) {
      return
    }

    if (!cntr.matches(CURR_QS)) {
      return
    }

    const horPane = domh.find.notStrict(cntr, HOR_PANE_QS)
    const verPane = domh.find.notStrict(cntr, VER_PANE_QS)
    const verHead = domh.find.notStrict(cntr, VER_HEAD_QS)

    const xOffset = horPane ? -1 * Math.round(getSize(horPane).width / 2) : 0
    const yOffset = verPane ? Math.round(getSize(verHead).height / 2) - Math.round(getSize(verPane).height / 2) : 0

    drawArea(
      cntr,
      bounds.hard.minWidth,
      bounds.hard.minHeight,
      bounds.base.width,
      bounds.base.height,
      '#FFA200',
      xOffset,
      yOffset)

    drawArea(
      cntr,
      bounds.hard.maxWidth,
      bounds.hard.maxHeight,
      bounds.base.width,
      bounds.base.height,
      '#ff0000',
      xOffset,
      yOffset)

    drawArea(
      cntr,
      bounds.soft.minWidth,
      bounds.soft.minHeight,
      bounds.base.width,
      bounds.base.height,
      '#00FF93',
      xOffset,
      yOffset)

    drawArea(
      cntr,
      bounds.soft.maxWidth,
      bounds.soft.maxHeight,
      bounds.base.width,
      bounds.base.height,
      '#00ff00',
      xOffset,
      yOffset)
  }
}
